if($('.homepage-box').length){
    $('.welcome').before($('.homepage-box .welcome p img[style="float: left;"]').closest('p'));
}

if($('#products-1').length){
    $('#products-1').after('<div class="text-center homepageButtons"><a href="'+buttonLink+'" class="btn btn-primary">'+buttonText+'</a></div>')
}

if($('.in-index').length){
    if($('.homepage-box.before-carousel').length){
        $('.homepage-box.before-carousel').before($('.benefitBanner .mainClaim'));
        $('.homepage-box.before-carousel').before($('.benefitBanner .usp'));
    }
}